import PointsOfInterest from '../../../../components/points-of-interest/points-of-interest.desktop';
import pointsOfInterest from './points-of-interest';

export default pointsOfInterest(PointsOfInterest);
